import React from "react";
import PropTypes from "prop-types";

export function ContentWrapper(props) {
  return <div className={props.className}>{props.children}</div>;
}

ContentWrapper.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * child components inside wrapper
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};
ContentWrapper.defaultProps = {
  className: "",
};
